import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { getRole } from 'utils/common';

const isActive = (items, pathname) => !!items?.some((item) => item.url === pathname || isActive(item.children, pathname));

// ==============================|| SIDEBAR MENU LIST ||============================== //
const MenuList = () => {
  const role = getRole();
  const chatLink = localStorage.getItem('chat_link');
  const { pathname } = useLocation();

  const filterItems = (items) =>
    items
      .filter((item) => (item.minRole || 0) <= role)
      .filter((item) => item.id !== 'chat' || chatLink)
      .map((item) => (item.children ? { ...item, children: filterItems(item.children) } : item))
      .filter((item) => item.type !== 'collapse' || item.children.length > 0);

  const visibleGroups = menuItem.items
    .map((item) => {
      if (item.type !== 'group' || (item.minRole || 0) > role) {
        return null;
      }
      const children = filterItems(item.children);
      return children.length > 0 ? { ...item, children } : null;
    })
    .filter(Boolean);

  const activeGroupId = visibleGroups.find((group) => isActive(group.children, pathname))?.id;
  const [openGroupId, setOpenGroupId] = useState(() => activeGroupId || 'workspace');

  useEffect(() => {
    setOpenGroupId(activeGroupId || 'workspace');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <>
      {visibleGroups.map((item, index) => (
        <NavGroup
          key={item.id}
          item={item}
          first={index === 0}
          active={item.id === activeGroupId}
          open={item.id === openGroupId}
          onToggle={() => setOpenGroupId((prev) => (prev === item.id ? null : item.id))}
        />
      ))}
    </>
  );
};

export default MenuList;
